import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { TopBar } from './components/TopBar';
import { LoginPage } from './pages/LoginPage';
import { DirectoryPage } from './pages/DirectoryPage';
import { CreateRoundPage } from './pages/CreateRoundPage';
import { GamePage } from './pages/GamePage';
import { RoundSettingsPage } from './pages/RoundSettingsPage';
import { LiveFlightPage } from './pages/LiveFlightPage';
import { ResultPage } from './pages/ResultPage';
import { ChallengePage } from './pages/ChallengePage';
import { JoinPage } from './pages/JoinPage';
import { AdminPage } from './pages/AdminPage';
import { AccountPage } from './pages/AccountPage';
import { SettingsPage } from './pages/SettingsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { Footer } from './components/Footer';

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="app">
        <div className="container page center"><div className="spinner" style={{ margin: '10vh auto' }} /></div>
      </div>
    );
  }

  return (
    <div className="app">
      <TopBar />
      {!user ? (
        <div className="page">
          <Routes>
            <Route path="/datenschutz" element={<PrivacyPage />} />
            <Route path="*" element={<LoginPage />} />
          </Routes>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<DirectoryPage />} />
          <Route path="/new" element={<CreateRoundPage />} />
          <Route path="/round/:id" element={<GamePage />} />
          <Route path="/round/:id/live" element={<LiveFlightPage />} />
          <Route path="/round/:id/settings" element={<RoundSettingsPage />} />
          <Route path="/result/:id" element={<ResultPage />} />
          <Route path="/challenge/:code" element={<ChallengePage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/konto" element={<AccountPage />} />
          <Route path="/einstellungen" element={<SettingsPage />} />
          <Route path="/datenschutz" element={<PrivacyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
      <Footer />
    </div>
  );
}
